import React from "react";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="pt-5 footer-middle">
                <div className="container">
                    <div className="row">
                        {/* Contact Info */}
                        <div className="col-lg-3 col-sm-6">
                            <div className="widget">
                                <h4 className="widget-title">Contact Info</h4>

                                <ul className="contact-info">
                                    <li>
                                        <span className="contact-info-label">
                                            Ghayar E-Commerce
                                        </span>
                                        GHAYAR AUTO SPARE PARTS TRADING L.L.C is a limited liability company (LLC) registered in the Emirate of Dubai in the UAE, a member of Dubai SME No. (8258), and a member of the National Program No. (DUB003385).
                                    </li>

                                    <div className="row mb-0">
                                        <li className="col-md-6">
                                            <span className="contact-info-label">Phone</span>
                                            <a href="tel:+971800442522">+971 800 442522</a>
                                        </li>

                                        <li className="col-md-6">
                                            <span className="contact-info-label">Email</span>
                                            <a href="mailto:business@ghayar.com">
                                                business@ghayar.com
                                            </a>
                                        </li>
                                    </div>

                                    <div className="row">
                                        <li className="col-md-12">
                                            <a href="https://business.ghayar.com/contact">
                                                <span className="contact-info-label">
                                                    Our Location
                                                </span>
                                            </a>
                                            <p>
                                                Ajman, AL Rawda 1, Algeria St, Al Meera Building, M002,
                                                Warehouse No. 3 – Umm Dera – New Industrial Area – Emirate
                                                of Umm Al Quwain
                                            </p>
                                        </li>

                                        <li className="col-md-6">
                                            <span className="contact-info-label">
                                                Working Hours
                                            </span>
                                            8:30 AM – 6:00 PM
                                        </li>
                                    </div>
                                </ul>

                                <div
                                    className="social-icons"
                                    style={
                                        window.innerWidth <= 768
                                            ? { display: "flex", justifyContent: "center" }
                                            : {}
                                    }
                                >
                                    <a
                                        href="https://www.facebook.com/ghayar.ae"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="social-icon"
                                    >
                                        <i className="ri-facebook-line"></i>
                                    </a>

                                    <a
                                        href="https://www.youtube.com/@ghayarautospareparts?sub_confirmation=1"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="social-icon"
                                    >
                                        <i className="ri-youtube-line"></i>
                                    </a>

                                    <a
                                        href="https://www.instagram.com/ghayar.ae"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="social-icon"
                                    >
                                        <i className="ri-instagram-line"></i>
                                    </a>

                                    <a
                                        href="https://bit.ly/2xPA8kY"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="social-icon"
                                    >
                                        <i className="ri-twitter-x-line"></i>
                                    </a>
                                </div>

                            </div>
                        </div>

                        {/* Customer Service */}
                        <div className="col-lg-3 col-sm-6">
                            <div className="widget">
                                <h4 className="widget-title">Customer Service</h4>
                                <ul className="links">
                                    <li><a href="https://business.ghayar.com/faqs">Help & FAQs</a></li>
                                    <li><a href="https://business.ghayar.com/privacy-policy">Privacy Policy</a></li>
                                    <li><a href="https://business.ghayar.com/delivery">Delivery & Shipment</a></li>
                                    <li><a href="https://business.ghayar.com/cancelation">Cancellation & Return</a></li>
                                    <li><a href="https://business.ghayar.com/warranty-coverage">Warranty Coverage</a></li>
                                    <li><a href="https://business.ghayar.com/international-customers">International Customers</a></li>
                                </ul>
                            </div>
                        </div>

                        {/* For Users */}
                        <div className="col-lg-3 col-sm-6">
                            <div className="widget">
                                <h4 className="widget-title">For Users</h4>
                                <ul>
                                    <li><a href="https://business.ghayar.com/signup">Login</a></li>
                                    <li><a href="https://business.ghayar.com/signup">Create Account</a></li>
                                    <li><a href="https://business.ghayar.com/my-account">My Account</a></li>
                                    <li><a href="https://business.ghayar.com/my-account/orders">My Orders</a></li>
                                    <li><a href="https://business.ghayar.com/my-account/details">Profile</a></li>
                                </ul>
                            </div>
                        </div>

                        {/* About Us */}
                        <div className="col-lg-3 col-sm-6">
                            <div className="widget">
                                <h4 className="widget-title">About Us</h4>
                                <ul>
                                    <li><a href="https://business.ghayar.com/about">Company Info</a></li>
                                    <li><a href="https://business.ghayar.com/easy-way-to-shop">Easy Way to Shop</a></li>
                                    <li><a href="https://business.ghayar.com/safe-shopping">Safe Shopping</a></li>
                                    <li><a href="https://business.ghayar.com/suppliers">Car Parts Online</a></li>
                                    <li><a href="https://business.ghayar.com/attractive-prices">Attractive Prices</a></li>
                                    <li><a href="https://business.ghayar.com/brands">Brands</a></li>
                                    <li><a href="/Career">Careers</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="container">
                <div className="footer-bottom">
                    <div className="container d-sm-flex align-items-center">
                        <div className="footer-left">
                            <span>&copy; Ghayar LLC – All rights reserved</span>
                        </div>

                        <img
                            src="/assets/images/GhayarTruck.png"
                            alt="Ghayar Truck"
                            style={{
                                height: "30px",
                                marginLeft: "auto",
                            }}
                        />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
